import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Subheader from 'shared/components/Subheader';
import PasswordReset from 'shared/components/forms/PasswordReset';
import apiClient from 'userportal/lib/ApiClient';
import Page from 'userportal/components/Page';

const PasswordResetPage = () => {
  const { t } = useTranslation('common');
  const { hash } = useParams();

  return (
    <Page
      centered
      subheader={(
        <Subheader center title={t(hash ? 'passwordReset.titleSetPassword' : 'passwordReset.titleRequest')}>
          <span>{t(hash ? 'passwordReset.subtitleSetPassword' : 'passwordReset.subtitleRequest', { name: t('name') })}</span>
        </Subheader>
      )}
      helmetTitle={t(hash ? 'passwordReset.titleSetPassword' : 'passwordReset.titleRequest')}
    >
      <div className="col-xl-4 col-lg-6 col-md-8 col-sm-8 col-xs-12">
        <PasswordReset apiClient={apiClient} app="userportal" hash={hash} />
      </div>
    </Page>
  );
};

export default PasswordResetPage;
